//
//
//
//
//
//
//
//
//

import FilesField from './FilesField.vue'
import FilesGroup from './FilesGroup.js'

export default {
  name: 'ReadonlyDocumentsField',
  components: {
    FilesField
  },
  props: {
    documents: {
      type: [Array, FilesGroup],
      default: function () {
        return []
      }
    },
    contentType: {
      type: String,
      default: null
    },
    sizeImg: {
      type: Number,
      default: 140
    }
  },
  data: function () {
    return {
      filesGroupLocal: null
    }
  },
  watch: {
    documents: {
      handler: function () {
        const filesGroup = new FilesGroup({
          categoryKey: -1,
          readonly: true
        })

        let documents
        if (this.documents != null && this.documents instanceof FilesGroup) {
          // this.filesGroupLocal = this.documents
          documents = this.documents.files.map(file => file.document)
        } else {
          documents = this.documents
        }

        if (documents) {
          documents.forEach(document => {
            filesGroup.pushFile(document)
          })
        }

        this.filesGroupLocal = filesGroup
      },
      immediate: true
    }
  }
  // TODO : почему при использовании computed не срабатывает реактивность для fileWrapper.smallBlob ?
  // computed: {
  //   filesGroup: function () {
  //     const filesGroup = new FilesGroup({
  //       categoryKey: -1,
  //       readonly: true
  //     })

  //     const documents = this.documents
  //     if (documents) {
  //       documents.forEach(document => {
  //         filesGroup.pushFile(document)
  //       })
  //     }
  //     console.log('filesGroup', filesGroup)
  //     return filesGroup
  //   }
  // }
}
